import React from 'react';
import { CheckCircle, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
interface ApprovedBannerProps {
  approvedBy: string;
  approvedAt: string;
  total: number;
}
export function ApprovedBanner({
  approvedBy,
  approvedAt,
  total
}: ApprovedBannerProps) {
  const formatDate = (isoString: string) => {
    const date = new Date(isoString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
    });
  };
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-500 p-8 mb-6 shadow-xl" data-id="element-60">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-64 h-64 opacity-20" data-id="element-61">
        <Sparkles size={256} className="text-white" data-id="element-62" />
      </div>
      <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-white/10 rounded-full blur-2xl" data-id="element-63"></div>
      <div className="absolute -top-8 -right-8 w-40 h-40 bg-white/10 rounded-full blur-2xl" data-id="element-64"></div>

      {/* Content */}
      <div className="relative z-10" data-id="element-65">
        <div className="flex items-start gap-4 mb-4" data-id="element-66">
          <motion.div initial={{
          scale: 0,
          rotate: -180
        }} animate={{
          scale: 1,
          rotate: 0
        }} transition={{
          delay: 0.2,
          type: 'spring',
          stiffness: 200
        }} className="p-3 bg-white/20 backdrop-blur-sm rounded-2xl" data-id="element-67">
            <CheckCircle size={32} className="text-white" data-id="element-68" />
          </motion.div>
          <div className="flex-1" data-id="element-69">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3
          }} className="text-3xl font-bold text-white mb-2" data-id="element-70">
              Commission Approved!
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4
          }} className="text-emerald-50 text-sm" data-id="element-71">
              Your commission has been approved and is ready for payout
            </motion.p>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20" data-id="element-72">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-73">
            <div data-id="element-74">
              <p className="text-xs text-emerald-100 font-semibold uppercase tracking-wider mb-1" data-id="element-75">
                Approved Amount
              </p>
              <p className="text-2xl font-bold text-white" data-id="element-76">
                $
                {total.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
              </p>
            </div>
            <div data-id="element-77">
              <p className="text-xs text-emerald-100 font-semibold uppercase tracking-wider mb-1" data-id="element-78">
                Approved By
              </p>
              <p className="text-lg font-bold text-white" data-id="element-79">{approvedBy}</p>
            </div>
            <div data-id="element-80">
              <p className="text-xs text-emerald-100 font-semibold uppercase tracking-wider mb-1" data-id="element-81">
                Approved On
              </p>
              <p className="text-lg font-bold text-white" data-id="element-82">
                {formatDate(approvedAt)}
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </motion.div>;
}